module.exports = __webpack_public_path__ + "static/media/pf7.3eeab328.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf7.png
// module id = 2667
// module chunks = 0